import React, { useState, useEffect } from 'react'
import DashboardBlock from './dashboardwidgetsblock';

export default function PendingViolation({ violationData, totalCount, loading }) {
    const [amount, setAmount] = useState(0);
    const [pendingviolation, setPendingViolation] = useState(0);

    useEffect(() => {
        const data = violationData;
        if (data.sumAmount) {
            setPendingViolation(data.cases);
            setAmount(data.sumAmount);
        } else {
            setPendingViolation(0);
            setAmount(0);
        }
    }, [violationData]);

    return (
        <div style={{ position: 'relative' }}>
            <DashboardBlock
                classname="violence-block"
                title="Violation pending on Bank side for review"
                titlecolor={"#707070"}
                count={pendingviolation}
                countcolor="#303A78"
                total={totalCount}
                amount={amount}
                amount_color="#707070"
                showpercent={true}
                percentcolor="#707070"
                paddingTop="25px"
                loader={loading} />
        </div>
    )
}
